<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon v-if="windowWidth < 1281" class="sm:inline-flex cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />

        <vs-spacer />

        <!-- <i18n /> -->

        <!-- <search-bar /> -->

<!--        <div class="dropdown-button-container">-->

          <!-- <vs-dropdown style="padding-left: 11px; font-size: 20px;" vs-custom-content vs-trigger-click class="cursor-pointer">
            <plus-icon size="1.5x" class="custom-class" />
            <vs-dropdown-menu >
              <vs-dropdown-item class="" style="padding: 5px;">
                <user-plus-icon size="1.5x" class="custom-class" style="vertical-align: bottom;" />&nbsp;&nbsp;
                New Person
              </vs-dropdown-item>
              <vs-dropdown-item class="" style="padding: 5px;">
                <briefcase-icon size="1.5x" class="custom-class" style="vertical-align: bottom;" />&nbsp;&nbsp;
                New Company
              </vs-dropdown-item>
              <vs-dropdown-item class="" style="padding: 5px;">
                <disc-icon size="1.5x" class="custom-class" style="vertical-align: bottom;" />&nbsp;&nbsp;
                New Opportunity
              </vs-dropdown-item>
              <vs-dropdown-item class="" style="padding: 5px;">
                <file-text-icon size="1.5x" class="custom-class" style="vertical-align: bottom;" />&nbsp;&nbsp;
                New Task
              </vs-dropdown-item>
              <vs-dropdown-item class="" style="padding: 5px;">
                <folder-plus-icon size="1.5x" class="custom-class" style="vertical-align: bottom;" />&nbsp;&nbsp;
                New Project
              </vs-dropdown-item>
              <vs-dropdown-item class="" style="padding: 5px;">
                <users-icon size="1.5x" class="custom-class" style="vertical-align: bottom;" />&nbsp;&nbsp;
                New Lead
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown> -->
<!--        </div>-->

        <!-- <cart-drop-down /> -->

        <ul class="flex mx-2 extra_menus">
          <li style="padding: 0 .5rem;" @click="$router.push('/pages/schedule').catch(() => {})">
            <vs-tooltip text="Calendar" position="bottom" color="primary">
              <feather-icon icon="CalendarIcon" />
            </vs-tooltip>
          </li>
          <li style="padding: 0 .5rem;" @click="$router.push('/pages/email').catch(() => {})">
            <vs-tooltip text="Email" position="bottom" color="primary">
              <feather-icon icon="MailIcon" />
            </vs-tooltip>
          </li>
          <li style="padding: 0 .5rem;" @click="$router.push('/pages/tasks-project').catch(() => {})">
            <vs-tooltip text="Task" position="bottom" color="primary">
              <feather-icon icon="CheckSquareIcon" />
            </vs-tooltip>
          </li>
          <li style="padding: 0 .5rem;" @click="$router.push('/pages/chat').catch(() => {})">
            <vs-tooltip text="Chat" position="bottom" color="primary">
              <feather-icon icon="MessageSquareIcon" />
            </vs-tooltip>
          </li>
        </ul>

        <notification-drop-down />

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import Bookmarks            from './components/Bookmarks.vue'
import I18n                 from './components/I18n.vue'
import SearchBar            from './components/SearchBar.vue'
import CartDropDown         from './components/CartDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import { PlusIcon, UserPlusIcon, BriefcaseIcon, DiscIcon, FileTextIcon, FolderPlusIcon, UsersIcon } from 'vue-feather-icons'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    Bookmarks,
    I18n,
    SearchBar,
    CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
    PlusIcon,
    UserPlusIcon,
    BriefcaseIcon,
    DiscIcon,
    FileTextIcon,
    FolderPlusIcon,
    UsersIcon
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>
<style>
.extra_menus .con-vs-tooltip {
  display: flex;
}
.extra_menus li {
  cursor: pointer;
}
</style>

